import { useState } from "react";
import { createContainer } from "unstated-next";

function useCurrentApplicationContainer() {
    const [currentApplicationId, setCurrentApplicationId] = useState<string | null>(null);
    const [currentOrganizationId, setCurrentOrganizationId] = useState<string | null>(null);

    const setApplicationId = (applicationId: string | null) => {
        setCurrentApplicationId(applicationId);
    };

    const clearApplicationId = () => {
        setCurrentApplicationId(null);
    };

    const setOrganizationId = (organizationId: string | null) => {
        setCurrentOrganizationId(organizationId);
    };

    const clearOrganizationId = () => {
        setCurrentOrganizationId(null);
    };

    return {
        currentApplicationId,
        currentOrganizationId,
        setApplicationId,
        clearApplicationId,
        setOrganizationId,
        clearOrganizationId
    };
}

const CurrentApplicationContainer = createContainer(useCurrentApplicationContainer);
export default CurrentApplicationContainer;
